import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function WarningSigns() {
  return <section className="py-20 md:py-28 bg-[#0A0A0A] text-[#FAF7F2]" data-id="element-292">
      <div className="max-w-3xl mx-auto px-4" data-id="element-293">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-294">
          <h2 className="text-2xl md:text-3xl font-bold font-serif text-[#C5A55A] mb-10" data-id="element-295">
            ⚠️ SI HOY:
          </h2>
        </motion.div>

        <div className="space-y-5 mb-12" data-id="element-296">
          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} data-id="element-297">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-298">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-299" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-300">
              El sexo es cada vez más escaso
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.2
        }} data-id="element-301">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-302">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-303" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-304">
              Sientes más cansancio que deseo
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.3
        }} data-id="element-305">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-306">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-307" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-308">
              Hablan más de responsabilidades que de pasión
            </p>
          </motion.div>

          <motion.div className="flex items-start gap-4" initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: 0.4
        }} data-id="element-309">
            <div className="mt-1 bg-[#C5A55A]/15 p-1.5 rounded-full flex-shrink-0" data-id="element-310">
              <CheckIcon className="w-4 h-4 text-[#C5A55A]" data-id="element-311" />
            </div>
            <p className="text-lg md:text-xl text-[#FAF7F2]/90 font-light" data-id="element-312">
              Te sientes acompañada… pero no elegida
            </p>
          </motion.div>
        </div>

        <motion.div className="space-y-2" initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: 0.5
      }} data-id="element-313">
          <p className="text-xl md:text-2xl text-[#FAF7F2]/80 font-light" data-id="element-314">
            No es exageración.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[#B91C1C]" data-id="element-315">
            Es enfriamiento.
          </p>
          <p className="text-lg md:text-xl text-[#FAF7F2]/70 font-light mt-4" data-id="element-316">
            Y el enfriamiento no se revierte solo.
          </p>
        </motion.div>
      </div>
    </section>;
}